export enum NoDataType {
  GENERAL = 'general',
  NETWORK = 'network',
  GPU = 'gpu',
  RELIABILITY = 'reliability',
}

export type DataStatus = {
  received: boolean;
  available: boolean;
};

export const isDataProcessing = (status: DataStatus): boolean =>
  status.received && !status.available;

export enum CostReportTab {
  COMPUTE_COST = 'COMPUTE_COST',
  NETWORK_COST = 'NETWORK_COST',
  EFFICIENCY = 'EFFICIENCY',
  TOTAL_COST = 'TOTAL_COST',
  GPU_UTILIZATION = 'GPU_UTILIZATION',
  RELIABILITY = 'RELIABILITY',
}

export enum CostReportPriceType {
  DEFAULT = 'DEFAULT',
  LIST = 'LIST',
}
